// extracted by mini-css-extract-plugin
export default {"icon":"iconicSearch_icon__4nBov"};